/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "@mui/styled-engine-sc";
import Snackbar from "@mui/material/Snackbar";
import React from "react";

const StyledSnackbar = styled(({ ...props }) => <Snackbar {...props} />)`
  && {
  }
`;

export { StyledSnackbar };
